<style>
    .reminderCalendarInput {
        background-color: rgba(0, 0, 0, 0);
        border-radius: 10px !important;
        border-color: rgba(0, 0, 0, 0.1);
        width: 40%;
        height: 30px;
        padding: 0px 14px;
        font-size: 12px !important;
        -webkit-appearance: none;
    }

    .a-reminderCalendars {
        display: flex;
        align-items: center;
        height: 50px;
        justify-content: space-between;
    }

        .a-reminderCalendars span.badge {
            margin-top: 0px !important;
            position: static !important;
        }

    .card-reminderCalendars {
        box-shadow: none !important;
        border: 1px solid rgba(0, 0, 0, 0.1) !important;
        border-top: none !important;
    }

    .collapse-reminderCalendars {
        max-height: 42vh !important;
        overflow-x: auto !important;
    }
	.collapse-a:before {
		font-family: "Font Awesome 5 Free";
		content: "\f067";
		margin-left: 10px
	}

	.collapse-a .collapse-a-title:before {
		content: "جزئیات بیشتر";
	}

	.collapse-a.lessDetails:before {
		font-family: "Font Awesome 5 Free";
		content: "\f068";
		margin-left: 10px
	}

	.collapse-a.lessDetails .collapse-a-title:before {
		content: "جزئیات کمتر";
	}

	.v-select ul li {
		padding: 10px 5px !important
	}
</style>
<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    <span v-if="hasTaskId==true">تکرار وظیفه</span>
                    <span v-else>ثبت یادآور</span>
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="reminderModel.title" @input="v$.reminderModel.title.$touch()" :class="{invalid:v$.reminderModel.title.$error}">
                        <p class="text-danger" v-if="v$.reminderModel.title.required.$invalid && v$.reminderModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                        <p class="text-danger" v-if="v$.reminderModel.title.maxLength.$invalid && v$.reminderModel.title.$dirty">عنوان نباید بیش از ۱۵۰ کاراکتر باشد..</p>

                    </div>
                    <div class="mb-3" id="drpUserId" style="display:none">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="reminderModel.userId" label="title" placeholder="یادآور برای" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <p class="text-danger" v-if="v$.reminderModel.userId.required.$invalid && v$.reminderModel.userId.$dirty">لطفا یادداشت برای را انتخاب کنید.</p>
                    </div>



                    <div class="mb-4">
                        <div class="d-flex align-items-center">
                            <label class="w-25 mb-0 text-center font-12">تکرار هر</label>
                            <input class="form-control px-2 w-25 rounded-sm text-center" style="height:35px" type="number" v-model="reminderModel.interval" @input="v$.reminderModel.interval.$touch()" :class="{invalid:v$.reminderModel.interval.$error}" @change="calcCalendar">
                            <v-select class="w-50 mr-2" :class="{invalid:v$.reminderModel.reminderRepeatTypeId.$error}" dir="rtl" label="title" placeholder="نوع تکرار" :filterable="true" :options="reminderTypeList" :reduce="p => p.reminderRepeatTypeId" v-model="reminderModel.reminderRepeatTypeId">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                            <label class="w-25 mb-0 text-center font-12">یک بار</label>
                        </div>
                        <p class="text-danger" v-if="v$.reminderModel.interval.required.$invalid && v$.reminderModel.interval.$dirty">لطفا نوع تکرار را وارد کنید.</p>
                        <p class="text-danger" v-if="v$.reminderModel.reminderRepeatTypeId.required.$invalid && v$.reminderModel.reminderRepeatTypeId.$dirty">لطفا نوع تکرار را وارد کنید.</p>

                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-calendar-check color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.startDate!==null}">تاریخ شروع</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="reminderModel.startDate"
                                   id="startDT"
                                   :class="{invalid:v$.reminderModel.startDate.$error}" />
                        </div>
                        <p class="text-danger" v-if="v$.reminderModel.startDate.required.$invalid && v$.reminderModel.startDate.$dirty">لطفا تاریخ شروع را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required">
                            <i class="input-icon fa fa-clock color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.startTime!==null}">ساعت ارسال</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="reminderModel.startTime"
                                   id="startT"
                                   :class="{invalid:v$.reminderModel.startTime.$error}" :readonly="reminderModel.taskId!=null" />
                        </div>
                        <date-picker type="time" v-model="reminderModel.startTime" :auto-submit="true" format="HH:mm" element="startT" :jumpMinute="5" @change="calcCalendar" v-if="reminderModel.taskId==null" />
                        <p class="text-danger" v-if="v$.reminderModel.startTime.required.$invalid && v$.reminderModel.startTime.$dirty">لطفا ساعت ارسال را وارد کنید.</p>
                    </div>

                    <div>
                        <div class="input-style input-style-2 has-icon input-required mb-3">
                            <i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.endDate!==null}">تاریخ پایان</span>
                            <input type="text"
                                   class="form-control ltr d-inline-block"
                                   v-model="reminderModel.endDate"
                                   id="endDT" />
                        </div>
                        <p class="text-danger" v-if="v$.reminderModel.endDate.required.$invalid && v$.reminderModel.endDate.$dirty">لطفا تاریخ پایان را وارد کنید.</p>

                    </div>

                    <div class="checkboxRow mb-3">
                        <div class="fac fac-checkbox fac-green">
                            <span></span>
                            <input id="box3-fac-checkbox" type="checkbox" v-model="reminderModel.onHoliday">
                            <label for="box3-fac-checkbox">ارسال در روزهای تعطیل</label>
                        </div>
                        <div class="fac fac-checkbox fac-orange">
                            <span></span>
                            <input id="box5-fac-checkbox" type="checkbox" v-model="reminderModel.onDayAfterHoliday">
                            <label for="box5-fac-checkbox">ارسال در فردای روز تعطیل</label>
                        </div>
                        <div class="fac fac-checkbox fac-red">
                            <span></span>
                            <input id="box6-fac-checkbox" type="checkbox" v-model="reminderModel.disabled">
                            <label for="box6-fac-checkbox">غیرفعال</label>
                        </div>
                    </div>

                    <div class="card mx-0 mb-3">
                        <div class="list-group list-custom-small list-icon-0 bg-green1-dark px-2 collapse-description-box">
                            <a class="pr-1" data-toggle="collapse" href="#collapse-5">
                                <i class="far fa-calendar"></i>
                                <span>جزئیات تاریخ ارسال</span>
                                <i class="fa fa-angle-down"></i>
                            </a>
                        </div>
                        <div class="collapse pr-3 pl-2 collapse-reminderCalendars border rounded-sm" id="collapse-5">
                            <div class="list-group list-custom-small">
                                <a class="a-reminderCalendars" v-for="c in reminderCalendars" :key="c.tempId">
                                    <div class="d-flex align-items-center">
                                        <i class="fa font-14 fa-calendar-check rounded-sm shadow-m bg-yellow1-dark"></i>
                                        <span v-show="c.edit == false" @click="onClickCalendarLable(c)">{{c.calendarDateTime}}</span>
                                        <input class="reminderCalendarInput"
                                               v-model="c.calendarDateTime"
                                               v-show="c.edit"
                                               :id="'c'+c.tempId" />
                                        <span @click="onDateChanged(c)" v-show="c.edit" class="fa font-20 fa-check-square shadow-m mr-2 color-green1-dark"></span>

                                        <date-picker v-show="c.edit" type="date" v-model="c.calendarDateTime" format="jYYYY/jMM/jDD" :element="'c'+c.tempId" />
                                    </div>
                                    <div>
                                        <span class="badge bg-red2-dark font-10 position-static" v-if="c.isHoliday">تعطیل</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!--<div class="input-style input-style-2 has-icon input-required">
        <i class="input-icon fa fa-pen color-magenta2-light"></i>
        <span class="color-highlight" :class="{'input-style-1-active' : reminderModel.description!==null}">توضیحات</span>
        <textarea v-model="reminderModel.description" class="form-control line-height-m text-justify" rows="2" style="height:200px" @input="v$.reminderModel.description.$touch()" :class="{invalid:v$.reminderModel.description.$error}"></textarea>
        <p class="text-danger" v-if="v$.reminderModel.description.maxLength && v$.reminderModel.description.$dirty">توضیحات نباید بیش از ۱۰۰۰ کاراکتر باشد..</p>
    </div>-->

                    <div class="mb-3">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span :class="{'input-style-1-active' : reminderModel.description!==null}">توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>
                        <div class="collapse collapse-reminderCalendars" id="collapse-description">
                            <textarea v-model="reminderModel.description" class="form-control line-height-m text-justify rounded-sm" rows="2" style="height:200px" @input="v$.reminderModel.description.$touch()" :class="{invalid:v$.reminderModel.description.$error}"></textarea>
                            <p class="text-danger" v-if="v$.reminderModel.description.maxLength.$invalid && v$.reminderModel.description.$dirty">توضیحات نباید بیش از ۱۰۰۰ کاراکتر باشد..</p>

                        </div>
                    </div>

                    <div class="collapse pt-3" id="collapse-moreDetails">

                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                {{ option.fullTitle }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="reminderModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>

                    </div>

                    <button data-toggle="collapse" data-target="#collapse-moreDetails" class="btn btn-xxs mb-3 btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
                        <span class="collapse-a-title"></span>
                    </button>
                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="CreateReminder">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <date-picker type="date" v-model="reminderModel.endDate" format="jYYYY/jMM/jDD" element="endDT" @change="calcCalendar" />

        <date-picker type="date" v-model="reminderModel.startDate" format="jYYYY/jMM/jDD" element="startDT" @change="calcCalendar" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>

        <Help-Menu title="راهنمای ثبت یادآور" keyEn="TaskList"></Help-Menu>
        <!--<div id="createReminderHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">راهنمای ثبت یادآور</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-Reminder.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-Reminder.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
                                <i class="far font-14 fa-check-circle color-red2-dark"></i>
                                <span class="font-14">راهنمای ثبت یادآور</span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-1" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-riminder.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/add-riminder.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required,
        maxLength
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import HelpMenu from '../Components/HelpMenu.vue';

    import DatePicker from 'vue3-persian-datetime-picker';
    import VueSimpleAlert from 'vue3-simple-alert';

    export default {
        components: {
            "Help-Menu": HelpMenu,
            DatePicker
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                modified: false,
                reminderModel: {
                    taskId: null,
                    interval: null,
                    reminderRepeatTypeId: null,
                    reminderId: 0,
                    startDate: null,
                    startTime: null,
                    endDate: null,
                    onHoliday: false,
                    onDayAfterHoliday: false,
                    title: null,
                    userId: 0,
                    description: null,
                    disabled: false,
                    reminderCalendars: [],
                    attList: [],
                    leadId: null,

                    projectId: null,
                    invoiceId: null,
                    preInvoiceId: null,
                    contractId: null,
                    letterId: null,
                    personId: null,
                    meetingId: null,
                    preBuyInvoiceId: null,
                    buyId: null,

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            reminderTypeList() {
                return this.$store.getters.GetReminderTypeList;
            },
            reminderCalendars() {
                return this.$store.getters.GetReminderCalendarList;
            },
            hasTaskId() {
                return this.$route.params.taskId != null && this.$route.params.taskId != 0
            },
            propsToWatch() {
                return `${this.reminderModel.title}|${this.reminderModel.description}|${this.reminderModel.interval}|${this.reminderModel.onDayAfterHoliday}|${this.reminderModel.disabled}|${this.reminderModel.attList}`;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },


            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        watch: {
            propsToWatch: {
                handler: function () {
                    console.log(this.modified);
                    this.modified = true;
                },
                deep: true
            },
            localUserListList: {
                //handler: function () {
                //}
            },
            'reminderModel.personId'(value) {
                this.onchangePerson();
            },
            'reminderModel.projectId'(value) {
                this.onchangeProject();
            },
            'reminderModel.preInvoiceId'(value) {
                this.onchangePreInvoice();
            },
            'reminderModel.contractId'(value) {
                this.onchangeContract();
            },
            'reminderModel.meetingId'(value) {
                this.onchangeMeeting();
            },
            'reminderModel.invoiceId'(value) {
                this.onchangeInvoice();
            },
            'reminderModel.letterId'(value) {
                this.onchangeLetter();
            },
            'reminderModel.buyId'(value) {
                this.onchangeBuy();
            },
            'reminderModel.reminderRepeatTypeId'(value) {
                this.calcCalendar();
            },
        },
        created() {
            this.$store.dispatch("CheckUserSMS");
            this.$store.dispatch("GetReminderTypeListFromServer");


            this.$store.dispatch("GetPersonListFromServer", {});
            this.$store.dispatch("GetProjectListFromServer", {});
            this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
            this.$store.dispatch("GetContractAbstractForPerson", {});
            this.$store.dispatch("GetInvoiceAbstractForPerson", {});
            this.$store.dispatch("GetLetterAbstractForPerson", {});
            this.$store.dispatch("GetMeetingAbstractForPerson", {});
            this.$store.dispatch("GetBuyAbstractForPerson", {});

            this.getUserList();
        },
        mounted() {
            if (this.hasTaskId) {
                this.getTaskInfo();
                this.reminderModel.interval = 1;
                this.reminderModel.reminderRepeatTypeId = 1;
            }
            else {
                this.getServerDateTime();
            }

            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },

        methods: {
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.reminderModel.projectId = null;
                this.reminderModel.invoiceId = null;
                this.reminderModel.preInvoiceId = null;
                this.reminderModel.contractId = null;
                this.reminderModel.letterId = null;
                this.reminderModel.meetingId = null;
                this.reminderModel.preBuyInvoiceId = null;
                this.reminderModel.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.reminderModel.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.reminderModel.contractId = null;
                this.reminderModel.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.reminderModel.personId,
                    projectId: this.reminderModel.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.reminderModel.personId,
                    projectId: this.reminderModel.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                        projectId: this.reminderModel.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.reminderModel.contractId = null;
                this.reminderModel.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.reminderModel.preInvoiceId,
                    contractId: this.reminderModel.contractId,
                    personId: this.reminderModel.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.reminderModel.invoiceId = null;
                this.reminderModel.buyId = null;
                this.reminderModel.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.reminderModel.preInvoiceId,
                    contractId: this.reminderModel.contractId,
                    personId: this.reminderModel.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.reminderModel.personId,
                    projectId: this.reminderModel.projectId,
                    contractId: this.reminderModel.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.reminderModel.personId,
                    prebuyInvoiceId: this.reminderModel.prebuyInvoiceId,
                    contractId: this.reminderModel.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.reminderModel.preInvoiceId,
                        contractId: this.reminderModel.contractId,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                        contractId: this.reminderModel.contractId,
                        projectId: this.reminderModel.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.reminderModel.personId,
                        prebuyInvoiceId: this.reminderModel.prebuyInvoiceId,
                        contractId: this.reminderModel.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },


            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    expiredControl: true
                });
                this.$http.get("Account/GetLogginedUserID")
                    .then(data => {
                        this.reminderModel.userId = data.data;
                        setTimeout(function () {
                            document.querySelectorAll("#drpUserId").forEach(a => a.style.display = "block");
                        }, 1000)
                    });
            },
            calcCalendar() {
                this.$store.dispatch("GetReminderCalendarListFromServer", {
                    reminderId: this.reminderModel.reminderId,
                    startDate: this.reminderModel.startDate,
                    endDate: this.reminderModel.endDate,
                    interval: this.reminderModel.interval,
                    typeId: this.reminderModel.reminderRepeatTypeId,
                    isChanged: true
                });
            },
            CreateReminder() {
                this.reminderModel.reminderCalendars = this.reminderCalendars;
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("CreateReminder", this.reminderModel);
                }

            },
            getIsHoliday(c) {
                this.$http.get("Reminder/IsHoliday?date=" + c.calendarDateTime)
                    .then(data => {
                        if (data.data == true) {
                            c.isHoliday = true;
                        }
                        else {
                            c.isHoliday = false;
                        }
                    });

            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        var m = data.data.split("_")
                        this.reminderModel.startDate = m[0];
                        this.reminderModel.startTime = m[1];
                    });

            },
            getTaskInfo() {
                this.$http.get("Task/getTaskInfoForReminder?taskId=" + this.$route.params.taskId)
                    .then(data => {
                        this.reminderModel = data.data;
                        this.reminderModel.interval = null;
                    });

            },

            SetAttList(e) {
                console.log(e);
                this.reminderModel.attList = e;
            },

            onClickCalendarLable(c) {
                var edited = this.reminderCalendars.filter(function (elem) {
                    if (elem.edit == true) return elem.tempId;
                });

                if (edited.length === 0) {
                    c.edit = true;
                    document.getElementById("c" + c.tempId).focus();
                }

            },
            onDateChanged(c) {
                this.getIsHoliday(c);
                c.edit = false;
                this.modified = true;
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },

        validations: {
            reminderModel: {
                interval: {
                    required,
                },

                title: {
                    required,
                    maxLength: maxLength(150)
                },
                userId: {
                    required,
                },
                reminderRepeatTypeId: {
                    required
                },
                startDate: {
                    required
                },
                startTime: {
                    required
                },
                endDate: {
                    required
                },
                description: {
                    maxLength: maxLength(1000)
                },

            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }

    };
</script>
